export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';
export const NOTIFICATION_DISMISS = 'NOTIFICATION_DISMISS';
export const NOTIFICATION_PIN = 'NOTIFICATION_PIN';

let nextNotificationId = 0;

export const addNotification = (message) => {
  nextNotificationId += 1;
  const createDate = new Date();

  // if the message returned is a React component
  // it will be handled differently in the notification
  // component
  let component;
  if (typeof message === 'object') {
    component = message;
  }

  return {
    type: NOTIFICATION_ADD,
    newNotification: {
      id: nextNotificationId,
      message,
      component,
      createDate,
      visible: true,
      pinned: false,
    },
  };
};

export const dismissNotification = id => ({
  type: NOTIFICATION_DISMISS,
  id,
});

export const pinNotification = id => ({
  type: NOTIFICATION_PIN,
  id,
});



// WEBPACK FOOTER //
// ./src/actions/notifications.js